import React from 'react';
import {
  Edit,
  SaveButton,
  SelectInput,
  SimpleForm,
  Toolbar,
  required,
  useNotify,
  useRedirect,
} from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import FormRecurringSend from '../../components/FormRecurringSend';
import { buildSavedMessage } from '../../components/FormRecurringSend/nextSend';

const toolbarSx = {
  justifyContent: 'space-between'
};

const statusChoices = [
  { id: true, name: 'Ativo' },
  { id: false, name: 'Pausado' },
];

const EditRecurringSend: React.FC = ({ ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const EditToolbar = (props) => {
    return (
      <Toolbar {...props} sx={toolbarSx}>
        <SaveButton />
      </Toolbar>
    );
  };

  return (
    <Permission permission={PERMISSIONS.UNIFIED_SEND}>
      <Edit
        {...props}
        title="Editar envio recorrente"
        // pessimistic: a edição cancela e recria o disparo de hoje, e só a resposta
        // do backend (todaySendAt) diz se ele ainda sai hoje
        mutationMode="pessimistic"
        mutationOptions={{
          onSuccess: (data: any, variables: any) => {
            const nextSendMessage = buildSavedMessage(variables?.data, data?.todaySendAt);
            if (nextSendMessage) {
              notify(`Envio recorrente atualizado. ${nextSendMessage}`, { type: 'info', autoHideDuration: 6000 });
            } else {
              notify('ra.notification.updated', { type: 'info', messageArgs: { smart_count: 1 } });
            }
            redirect('list', 'chains/chainId/recurring-send');
          },
        }}
      >
        <SimpleForm toolbar={<EditToolbar />}>
          <SelectInput
            source="isActive"
            label="Status"
            choices={statusChoices}
            validate={[required()]}
            sx={{ width: 200 }}
          />
          <FormRecurringSend />
        </SimpleForm>
      </Edit>
    </Permission>
  );
};

export default EditRecurringSend;
